import profileStore from "lib/stores/entities/profile";
import { useEffect } from "react";
import { getToken } from "utils/authStore";

function useProfile() {
  const user = profileStore((s) => s.user);
  const getProfile = profileStore((s) => s.getProfile);

  useEffect(() => {
    const token = getToken();

    // Do nothing if token is not available
    if (!token) {
      return;
    }

    // Get profile if token is available but user profile is still null
    if (!user) {
      getProfile();
    }
  }, [user]);

  return user;
}

export default useProfile;
